var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0065 20.0093C12.3144 20.0123 14.5517 19.2138 16.3362 17.7503L22.3047 23.7178C22.7021 24.1016 23.3354 24.0906 23.7193 23.6932C24.0937 23.3055 24.0937 22.6909 23.7193 22.3032L17.7518 16.3347C21.2475 12.0561 20.6129 5.75364 16.3342 2.25788C12.0555 -1.23788 5.75309 -0.603207 2.25733 3.67546C-1.23843 7.95412 -0.603757 14.2565 3.67491 17.7523C5.46197 19.2124 7.69884 20.0097 10.0065 20.0093Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5d411c03cf7c04e9d44ddebb5280cffa.svg";
export { ForwardRef as ReactComponent };